module.exports = __webpack_public_path__ + "static/media/kocka2REPR.b6d14338.png";